import { api } from 'services/api';

const subscriptionService = api
  .enhanceEndpoints({ addTagTypes: ['Subscriptions', 'BasketItems', 'PurchasablePatients'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      subscriptionGroups: builder.query<ResultModel<SubscriptionGroups>, SubscriptionGroupsRequest>({
        query: (body) => ({
          url: `/472760A23CCA7D1E9281663EA2/get-subscription-groups.json`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      subscriptions: builder.query<ResultModel<Subscriptions>, SubscriptionsRequest>({
        query: (body) => ({
          url: `/472760A23CCA7D1E9281663EA2/get-subscriptions.json`,
          method: 'POST',
          body,
        }),
        providesTags: [{ type: 'Subscriptions', id: 'LIST' }],
      }),
      subscriptionServices: builder.query<
        ResultModel<SubscriptionServices>,
        SubscriptionServicesRequest
      >({
        query: (body) => ({
          url: `/472760A23CCA7D1E9281663EA2/get-subscription-services.json`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      addSubscriptions: builder.mutation<
        ResultModel<AddSubscriptionsServices>,
        AddSubscriptionsServicesRequest
      >({
        query: (body) => ({
          url: `/472760A23CCA7D1E9281663EA2/add-subscriptions.json`,
          method: 'POST',
          body,
        }),
        invalidatesTags: [
          { type: 'Subscriptions', id: 'LIST' },
          { type: 'BasketItems', id: 'LIST' },
        ],
        extraOptions: { isProfile: true },
      }),
      getSubscriptionGroupsByOwner: builder.query<
        ResultModel<SubscriptionGroupsByOwner>,
        SubscriptionGroupsByOwnerRequest
      >({
        query: (body) => ({
          url: `/472760A23CCA7D1E9281663EA2/get-subscription-groups-by-owner.json`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      getSubscriptionGroupTermsOfUse: builder.query<
        ResultModel<SubscriptionGroupTermsOfUse>,
        SubscriptionGroupTermsOfUseRequest
      >({
        query: (body) => ({
          url: `/472760A23CCA7D1E9281663EA2/get-subscription-group-terms-of-use.json`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      getSubscriptionWithGroup: builder.query<
        ResultModel<SubscriptionWithGroup>,
        SubscriptionWithGroupRequest
      >({
        query: (body) => ({
          url: `/472760A23CCA7D1E9281663EA2/get-subscription-with-group.json`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      getPurchasablePatients: builder.query<
        ResultModel<PurchasablePatients>,
        PurchasablePatientsRequest
      >({
        query: (body) => ({
          url: `/472760A23CCA7D1E9281663EA2/get-purchasable-patients.json`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
        providesTags: [{ type: 'PurchasablePatients', id: 'LIST' }],
        invalidatesTags: [{ type: 'BasketItems', id: 'LIST' }],
      }),
    }),
  });

export const {
  useSubscriptionGroupsQuery,
  useSubscriptionsQuery,
  useSubscriptionServicesQuery,
  useAddSubscriptionsMutation,
  useGetSubscriptionGroupsByOwnerQuery,
  useGetSubscriptionGroupTermsOfUseQuery,
  useGetSubscriptionWithGroupQuery,
  useGetPurchasablePatientsQuery,
} = subscriptionService;

